import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NotFoundSection = styled.section`
  padding: 150px 0;
  text-align: center;
  min-height: 70vh;
  display: flex;
  align-items: center;
  
  .error-content {
    h1 {
      font-size: 8rem;
      font-weight: 800;
      color: #2e7d32;
      margin-bottom: 20px;
      
      span {
        color: #ff9800;
      }
    }
    
    h2 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #333;
      margin-bottom: 25px;
    }
    
    p {
      font-size: 1.2rem;
      color: #666;
      margin-bottom: 30px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }
    
    .btn {
      padding: 12px 30px;
      font-weight: 600;
      font-size: 1.1rem;
      border-radius: 50px;
      margin: 0 10px;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
    
    .btn-primary {
      background-color: #2e7d32;
      border-color: #2e7d32;
      
      &:hover {
        background-color: #1b5e20;
        border-color: #1b5e20;
      }
    }
    
    .btn-outline-primary {
      color: #2e7d32;
      border-color: #2e7d32;
      
      &:hover {
        background-color: #2e7d32;
        border-color: #2e7d32;
        color: #fff;
      }
    }
  }
`;

const NotFound = () => {
  return (
    <NotFoundSection>
      <Container>
        <div className="error-content">
          <h1>4<span>0</span>4</h1>
          <h2>Page Not Found</h2>
          <p>
            The page you are looking for might have been removed, had its name changed, 
            or is temporarily unavailable.
          </p>
          <div>
            <Button as={Link} to="/" className="btn-primary">
              Back to Home
            </Button>
            <Button as={Link} to="/contact" variant="outline-primary">
              Contact Us
            </Button>
          </div>
        </div>
      </Container>
    </NotFoundSection>
  );
};

export default NotFound;
